const getFbData = (): Record<string, string | null | undefined> => {
  const { cookie } = window.document;
  const fbpArr = /_fbp=(fb\.1\.\d+\.\d+)/.exec(cookie);
  const fbp = fbpArr && fbpArr[1];

  const fbcArr = cookie
    .split(';')
    .filter((c) => c.includes('_fbc='))
    .map((c) => c.split('_fbc=')[1]);

  const fbc = fbcArr && fbcArr[0];

  return { fbp, fbc };
};

export default getFbData;
